<div class="bg-white border border-gray-300 shadow-sm flex flex-col p-4 rounded-lg">
    <p *ngIf="label != ''" class="font-medium text-xl leading-6 tracking-normal text-[#212121]">{{label}}</p>
    <p *ngIf="description != ''" class="text-[#666666] text-sm mt-2">{{description}}</p>
    <div class="gap-4 grid grid-cols-1 md:grid-cols-3 mt-4">
        <ng-content></ng-content>
    </div>
</div>